<template>
  <div class="industry-index" :class="[industryBool?'hiddenY':'']">
    <div class="industry-top">
      <i class="icon-img icon-back" @click="goBack"></i>
      <span @click="industryClick">{{onlyIndustry.name}}<i class="icon-img icon-down-white"></i></span>
    </div>
    <transition enter-active-class="animated fadeInRight" leave-active-class="animated slideOutLeft">
      <industry-list v-if="industryBool" @industryBool="industryBoolVal" :current-page-bool="currentPageBool"></industry-list>
    </transition>
    <div class="industry-content">
      <div class="industry-search">
        <i class="icon-img icon-search-small" @click="searchBtn"></i>
        <i v-if="keyVal" class="icon-img icon-cuo-circle" @click="clearKeyVal"></i>
        <input type="text"
               v-model="keyVal"
               placeholder="请输入关键字"
               @keyup.enter="searchBtn"
        >
      </div>
      <phone-address :address-type="addressType" :parameter="parameter" @cityId="cityIdVal"></phone-address>
      <template v-if="lists&&lists.length">
        <div class="industry-list">
          <template v-for="(item,index) in lists">
            <only-list :item="item" :class-name="'phone-industry'+index" :lazy="lazy" :key="'industry-list'+index"></only-list>
          </template>
        </div>
      </template>
      <template v-else>
        <div class="phone-no-data">
          <img :src="$noData" alt="">
          <p>抱歉，暂无<span v-if="keyVal"> {{keyVal}} </span>相关内容</p>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import onlyList from '@/components/onlyList.vue'
import industryList from '@/components/Phone/industryList.vue'
import phoneAddress from '@/components/Phone/address.vue'
export default {
  name: 'phoneIndustryIndex',
  props: [''],
  data () {
    return {
      lists: [],
      parameter: {
      },
      lazy: {
        bool: false
      },
      onlyIndustry: {},
      typeId: 0,
      industryBool: false,
      keyVal: '',
      addressType: 1,
      page: 1,
      limit: 8,
      total: 0,
      cityId: 0,
      currentPageBool: false
    }
  },
  created () {
    let that = this;
    let currentParams = JSON.parse(this.publicJs.decode(that.$route.query));
    that.cityId = currentParams.cityId||0;
    that.typeId = currentParams.typeId||0;
    that.navData()
  },
  components: {
    onlyList: onlyList,
    phoneAddress: phoneAddress,
    industryList: industryList
  },
  mounted () {
    this.listScrollb()
  },
  methods: {
    listScrollb: function () {
      let that = this;
      that.$nextTick(function () {
        $('.industry-index').scroll(function (e) {
          if (that.publicJs.isScrollBottom(this)) {
            // 滚动到底端了 加载内容
            // 加载数据
            // 滚动到底端了 加载内容
            // 加载数据
            let p = that.page;
            let l = that.limit;
            if (p && l && (p * l < that.total)) {
              that.page++
            }
          }
        })
      })
    },
    navData: function () {
      let that = this;
      that.publicJs.navGetData(function (data) {
        if (data.code === 1) {
          let onlyType=that.publicJs.onlyTypeData(data.data,that.typeId);
          that.onlyIndustry = onlyType?onlyType:{'name': '全部行业','id': 0}
          if (that.typeId === 0) {
            that.httpData();
          }
        }
      })
    },
    httpData: function () {
      let that = this;
      let params = {
        cityId: that.cityId,
        typeId: that.typeId,
        page: that.page,
        limit: that.limit,
        keyWords: that.keyVal
      };
      console.log(params)
      that.httpAjax.getAjax('PanoWebService.asmx/GetPanoByWhere', params).then(function (data) {
        if (data.code === 1) {
          that.total = data.total;
          let currentData = JSON.parse(JSON.stringify(data.data));
          const search = that.keyVal;
          if (search) {
            that.lists = that.lists.concat(currentData.map(item => {
              let replaceReg = new RegExp(search, 'g')// 匹配关键字正则
              let replaceString = '<span style="color:red;">' + search + '</span>' // 高亮替换v-html值
              item.name = item.name.replace(replaceReg, replaceString) // 开始替换
              return item
            }))
          } else {
            that.lists = that.lists.concat(currentData)
          }
        }
      }, function (err) {
        console.log(err)
      })
    },
    industryClick: function () {
      this.industryBool = true
      this.currentPageBool = true
    },
    industryBoolVal: function (val) {
      this.industryBool = false
      if (val) {
        this.onlyIndustry = val
        this.typeId = val.id
      }
    },
    searchBtn: function () {
      if (this.keyVal) {
        this.page = 1
        this.lists = []
        this.httpData()
      }
    },
    clearKeyVal: function () {
      this.keyVal = ''
      this.page = 1
      this.lists = []
      this.httpData()
    },
    cityIdVal: function (val) {
      this.cityId = val
    },
    goBack: function () {
      let that = this
      let currentParams = that.publicJs.decodeFun(that.$route.query)
      this.$router.push({
        path: currentParams.cityId > 0 ? '/phoneCity' : '/phoneIndex',
        query: {
          key: that.publicJs.encode(JSON.stringify({
            cityId: currentParams.cityId,
            typeId: 0,
          })),
          '_': new Date().getTime()
        }
      })
    }
  },
  watch: {
    page: {
      handler: function (a, b) {
        let that = this
        if (a !== b) {
          if (a === 1) {
            that.lists = []
          }
          that.page = a
          that.httpData()
        }
      },
      deep: true
    },
    typeId: {
      handler: function (a, b) {
        let that = this
        if (a !== b) {
          that.lists = []
          if (that.page > 1) {
            that.page = 1
          } else {
            that.httpData()
          }
        }
      },
      deep: true
    },
    cityId: {
      handler: function (a, b) {
        let that = this;
        if (a !== b && that.onlyIndustry.id >= 0) {
          that.cityId=a;
          that.lists = [];
          if (that.page > 1) {
            that.page = 1
          } else {
            that.httpData()
          }
        }
      },
      deep: true
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .industry-top{
    position: fixed;
    top:0;
    left: 0;
    right: 0;
    background-color: #248DDF;
    z-index: 5;
    text-align: center;
    color: #fff;
    font-size: 17px;
    line-height: 1;
    padding: 15px 0;
    letter-spacing: 1px;
  }
  .industry-list{
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    margin: 10px -5px 0;
    -webkit-animation: fadeInUp 0.5s;
    -o-animation: fadeInUp 0.5s;
    animation: fadeInUp 0.5s;
  }
  .industry-list>div{
    width: 50%;
  }
  .industry-content{
    padding:60px 11px 20px;
  }
  .industry-search{
    height: 28px;
    background: #FFFFFF;
    border-radius: 14px;
    margin-bottom: 9px;
    position: relative;
    padding: 0 14px 0 28px;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
  }
  .icon-search-small{
    position: absolute;
    top:50%;
    margin-top: -8px;
    left: 10px;
  }
  .icon-cuo-circle{
    position: absolute;
    right: 10px;
    top:50%;
    margin-top: -6px;
  }
  input::placeholder{
    color: #999999;
  }
  input{
    font-size: 14px;
    line-height: 23px;
    color: black;
    display: block;
    width: 100%;
    height: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/Phone/industry/index.vue